/*
 * @Author: yzf
 * @Date: 2020-07-01 21:34:01
 * @LastEditTime: 2020-12-01 16:37:37
 * @LastEditors: yzf
 * @Description: 这是文件
 * @FilePath: /alex/Volumes/project/hex/wuwei/src/router/map.js
 * @大威天龙,世尊地藏,般若诸佛,般若巴麻空,没有bug
 */
import editor from './children/editor'
import pay from './children/pay'
import other from './children/other'
export default {
  ...editor,
  ...pay,
  ...other,
  '*': {
    name: 'not_found',
    meta: { title: '404' },
    component: (resolve) => {
      window.__isErrorHexApp = 1
      require(['../../static/404.vue'], resolve)
    }
  }
}
